module.exports = __webpack_public_path__ + "static/media/doctor2.0f684bcc.svg";